var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-detail"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.btn),function(item){return _c('span',{key:item.id,staticClass:"btn-option",class:{ 'active-chart-table': _vm.selectData == item.id },on:{"click":function($event){return _vm.chooseLabelFn(item.id)}}},[_vm._v(_vm._s(item.label))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }